<template>
  <div class="">
    <div class="row mt-3" v-if="!editmode">
      <div class="col">
        <button class="btn btn-success" v-on:click="editmode = true">
          <icon :icon="['fad', 'users-class']"/>&nbsp;{{_[abstract.setting_submission_id].studygroup.button_add}}
        </button>
      </div>
    </div>
    <div v-if="editmode">
      <div class="row">
        <div class="col">
          <div class="alert alert-info">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fad', 'exclamation-circle']" class="fa-3x mx-auto my-auto"/>
              </div>
              <div class="col-8 d-flex">
                <div class="row my-auto">
                  <div class="col d-flex my-auto">
                    <Speaker :submission_id="abstract.setting_submission_id" area="studygroup"
                             textkey="helptext"></Speaker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="form-group">
            <label for="studygroup">
              <icon
                  :icon="['fad', 'users-class']"/>&nbsp;{{_[abstract.setting_submission_id].studygroup.inputtitle}}</label>
            <input type="text" class="form-control" id="studygroup" aria-describedby="studygroupHelp"
                   v-model="abstract.content__studygroup">
          </div>
        </div>
        <div class="col mt-auto">
          <div class="form-group pb-1">
            <button class="btn btn-sm btn-success" v-on:click="save">
              <icon :icon="['fal', 'save']" size="lg"/>&nbsp;{{_[0].buttons.save}}
            </button>
            <button class="btn btn-sm btn-warning ml-1" v-on:click="editmode = false">
              <icon :icon="['fad', 'ban']" size="lg"/>&nbsp;{{_[0].buttons.cancel}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations, mapGetters} from 'vuex'

  export default {
    name: "Studygroup",
    methods: {
      ...mapActions(['PUT_ABSTRACT', 'VALIDATE_TARGET']),
      async save() {
        await this.PUT_ABSTRACT(this.$route.params.id).then((result) => {
          this.$noty.success(this.wording[0].notify.save_success);
          this.editmode = false;
        }).catch((error) => {
          this.$noty.error(this.wording[0].notify.save_not_success);
        });
      }

    },
    data() {
      return {
        editmode: false,
        studygrouptext: ''
      };
    },
    computed: {
      ...mapState([
        'abstract', 'wording'
      ]),
      ...mapGetters([
        'getCurrentPages', 'getCurrentPageById', 'getCurrentPageByType', 'getPresenter'
      ]),
    },
  }
</script>

<style scoped>

</style>
